import React, { useMemo } from 'react';

import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import CloseIcon from '@mui/icons-material/Close';
import PhotoIcon from '@mui/icons-material/Photo';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import { Box, Typography } from '@mui/material';

import { StyledFile } from './StyledFile';

export interface FileItemProps {
  type: string;
  name: string;
  testId?: string;
  onClick?: VoidFunction;
  onDeleteFile?: (name: string) => void;
}

export const FileItem = ({ type, name, onDeleteFile, onClick, testId }: FileItemProps) => {
  const fileType = type?.split('/')[1] || type?.split('.')[1];

  const icon = useMemo(() => {
    switch (fileType) {
      case 'pdf':
        return <UploadFileRoundedIcon fontSize="large" sx={{ color: 'primary.main' }} />;
      case 'jpeg':
      case 'png':
      case 'svg':
        return <PhotoIcon fontSize="large" sx={{ color: 'primary.main' }} />;
      case 'mp3':
        return <PlayArrowRoundedIcon fontSize="large" sx={{ color: 'primary.main' }} />;
      default:
        return <AttachFileRoundedIcon fontSize="large" sx={{ color: 'primary.main' }} />;
    }
  }, [fileType]);

  return (
    <Box onClick={onClick} data-testid={testId}>
      <StyledFile onClick={onClick}>
        <Box display="flex" flexDirection="column">
          <Box m="0 auto">{icon}</Box>
          <Typography textAlign="center" variant="h4" color="primary.main" sx={{ textTransform: 'uppercase' }}>
            {fileType}
          </Typography>
        </Box>
        {onDeleteFile && (
          <Box
            onClick={() => onDeleteFile(name)}
            sx={{
              position: 'absolute',
              top: '-8px',
              right: '-8px',
              borderRadius: '50%',
              backgroundColor: 'primary.dark',
              width: '20px',
              height: '20px',
            }}
          >
            <CloseIcon
              fontSize="small"
              sx={{
                color: 'grey.100',
                zIndex: 1,
                cursor: 'pointer',
                width: '20px',
                height: '15px',
              }}
            />
          </Box>
        )}
      </StyledFile>
      <Typography width="96px" noWrap my={1} variant="text3" display="block" textAlign="center">
        {name}
      </Typography>
    </Box>
  );
};
